import { MeetingsAPI } from 'api'

export const getConnectedCalendarIds = async () =>
  MeetingsAPI.get(`/scheduling/settings/connected`)
